module.exports = __webpack_public_path__ + "static/media/russia.830d17ec.png";